export default "__VITE_ASSET__DsRhcvfm__"